export default "__VITE_ASSET__D9$WX5Dd__"